import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import ReactDOMClient from "react-dom/client";
//import { Router } from 'react-router';
import { createBrowserHistory } from 'history';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './styles/theme';
import * as serviceWorker from './serviceWorker';
import './styles/index.css';
import { LicenseManager } from 'ag-grid-enterprise';
import { CssBaseline, Button } from '@mui/material';
import { QueryClientProvider , QueryClient } from '@tanstack/react-query';
import NotifyBar from './components/NotifyBar';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import NotifyDismiss from './components/NotifyDismiss';
import Dialog from './components/Dialog/Dialog';
import SessionProvider from './providers/SessionProvider';
import LoaderComponent from './components/LoaderComponent';
import { ConfigProvider } from './providers';
import { AccessProvider } from './providers/AccessProvider/AccessProvider';
import IdleUserTimeoutProvider from './providers/IdleUserTimeoutProvider';
import QueryStatusProvider from './providers/QueryStatusProvider';
import WarningDialog from './components/WarningDialog/WarningDialog';
import {
  BrowserRouter as Router,
} from "react-router-dom";

const App = lazy(() => import('./App'));
const root = ReactDOMClient.createRoot(document.getElementById("root") as HTMLElement);
// Fires when user navigates away
const getUserConfirmation = (message: string, callback: any) => {
  const dialogMessages = JSON.parse(message);
  const modal = document.createElement('div');
  document.body.appendChild(modal);

  const withCleanup = (cleanUp: boolean) => {
    ReactDOM.unmountComponentAtNode(modal);
    document.body.removeChild(modal);
    callback(cleanUp);
  };

  root.render(
    <WarningDialog
       showPrompt={true}
       title={dialogMessages.title}
       contentText={dialogMessages.content}
       onNo={() => withCleanup(false)}
       onYes={() => withCleanup(true)}
    />,
    //modal,
  );
};

// Create your browser history
// const history = createBrowserHistory({ getUserConfirmation });

// Fires every time a location is updated
LicenseManager.setLicenseKey(
  //'CompanyName=Global Payments (NA, Alpharetta, GA),LicensedGroup=Real Time Routing,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=10,LicensedProductionInstancesCount=0,AssetReference=AG-032253,SupportServicesEnd=29_October_2023_[v2]_MTY5ODUzNDAwMDAwMA==66889b7a93b0d1eac2f6945d1445acfe',
  'Using_this_AG_Grid_Enterprise_key_( AG-046092 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Global Payments, Inc. )_is_granted_a_( Multiple Applications )_Developer_License_for_( 10 )_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_AG_Grid_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 28 October 2024 )____[v2]_MTczMDA3MzYwMDAwMA==183084ff96b5730992450de849967274',
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      staleTime: 600000,
      retry: false,
    },
  },
})

root.render(
  <React.StrictMode>
    <Suspense fallback={<LoaderComponent />}>
      <ConfigProvider>
        {/* <Router history={history}> */}
        <Router>
          <ThemeProvider theme={theme}>
            <SessionProvider>
              <QueryClientProvider client={queryClient}>
                <AccessProvider>
                  <IdleUserTimeoutProvider />
                  <CssBaseline />
                  <ReactQueryDevtools initialIsOpen={false} />
                    <QueryStatusProvider>
                      <NotifyBar
                        maxSnack={3}
                        action={(key:any) => <NotifyDismiss id={key} />}
                      >
                        <App />
                      </NotifyBar>
                    </QueryStatusProvider>
                  
                </AccessProvider>
                </QueryClientProvider>
            </SessionProvider>
          </ThemeProvider>
        </Router>
      </ConfigProvider>
    </Suspense>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
